import hyperdom from 'hyperdom'
import baggageNotes from '../../../flights/baggageNotes.jsx'
import placeholderPolyfill from '../../../placeholderPolyfill.jsx'
import TripSummaryDayTour from './tripSummaryDayTour.jsx'
import customSelect from '../../../customSelect.jsx'
import {Message, MessageTypes} from '../../../message.jsx'
import ConfirmationTab from '../../../defaultFlow/tabs/confirmation/confirmationTab.jsx'
import assetPath from "../../../assetPath.js"

export default class ConfirmationTabDayTour extends ConfirmationTab {
  constructor (options) {
    super(options)
    this.tripSummary = new TripSummaryDayTour({
      departure: options.departure,
      getTripDetails: this.getTripDetails,
      config: this.config,
    })
  }

  loadTab () {
    this.isExtoleEnabled = this.shouldCreateExtole()
    this.serverErrorsPanel.clear('payment')
    this.confirmation = this.loadConfirmation()
    this.confirmation.paymentHeader = (headerText, additionalText, imageName) => {
      return <div class='u-clearfix green-box'>
        <div className='confirmation__payment-status'>
          <div className='confirmation__payment-status-row'>
            {imageName !== 'paid'
              ? <img className='confirmation__payment-status-image' src={assetPath(`/public/img/${imageName}.svg`)} alt='success'/>
              : <div class='confirmation__payment-status-icon -new-ui_solid_check_circle'></div>
            }
            <div className='confirmation__payment-status-header'>{headerText}</div>
          </div>
          <div className='confirmation__reservation-code'>Your reservation code: <strong class="confirmation__booking-reference__code">{this.booking.booking.bookingReference}</strong></div>
        </div>
      </div>
    }
    this.loaded = true
  }

  renderLeadPassengerConfirmation () {
    const leadPassenger = this.booking.booking.leadPassenger
    const leadPassengerMessageClasses = []
    const leadPassengerClasses = ['confirmation__registration__lead_passenger']
    const leadPassengerBoxClass = 'o-accent-box-white'
    leadPassengerClasses.push(leadPassengerBoxClass)
    if (!this.config.features.showEdocs) {
      leadPassengerClasses.push('confirmation__registration__legacy')
    }

    if (this.registrationDetailsConfirmationDone) {
      leadPassengerMessageClasses.push('confirmation__registration__message_success', leadPassengerBoxClass)
      return <div class={leadPassengerMessageClasses}>
        {this.renderRegistrationDetailsConfirmationDone()}
      </div>
    }

    if (this.registrationDetailsConfirmationWarning) {
      leadPassengerMessageClasses.push('confirmation__registration__message_warning', leadPassengerBoxClass)
      return <div class={leadPassengerMessageClasses}>
        {this.renderRegistrationDetailsConfirmationWarning()}
      </div>
    }

    const countries = this.countries()
    return <div class="confirmation__registration">
      <div class="confirmation__registration__header">
        <div class='confirmation__section-title confirmation__registration__header_text'>Lead Passenger Confirmation</div>
      </div>
      <div class={leadPassengerClasses}>
        <form onsubmit={ev => {ev.preventDefault(); return this.submitRegistrationDetails()}}>
          <div class='confirmation__container'>
            <div class='o-form-item form-item-mobilephone'>
              <label for='mobileNumber' class='o-form-item__label'>
                Phone<span class='field-required'>*</span>
              </label>
              <div class="confirmation__mobile__inner">
                <div class={['confirmation__mobile__item', 'form-item-country-code']}>
                  {customSelect({
                    inputBinding: {get: () => countries[leadPassenger.mobileNumber.countryCode.toLowerCase()].internationalCallingCode},
                    selectBinding: [leadPassenger.mobileNumber, 'countryCode'],
                    selectId: 'pax-phone-country-code',
                    selectOnBlur: () => this.fieldVisited(leadPassenger.mobileNumber, 'countryCode'),
                    options: Object.keys(countries).map(countryCode => {
                      const country = countries[countryCode]
                      return {
                        value: countryCode.toUpperCase(),
                        display: `${country.name} (${country.internationalCallingCode})`,
                      }
                    }),
                  })}
                  {this.renderValidationError(leadPassenger.mobileNumber, 'internationalCode')}
                </div>
                <div class="confirmation__mobile-number confirmation__mobile-number form-item-mobile-number">
                  {placeholderPolyfill(
                    <input
                      id='mobileNumber'
                      class='o-form-item__txt-input'
                      placeholder='Mobile number'
                      type='text'
                      binding={[leadPassenger.mobileNumber, 'number']}
                      onblur={() => this.fieldVisited(leadPassenger.mobileNumber, 'number')}
                      name='number' />,
                    this.browserCapabilities
                  )}
                  {this.renderValidationError(leadPassenger.mobileNumber, 'number')}
                </div>
              </div>
            </div>
            <div class='o-form-item form-item-email-address confirmation__registration__email-container'>
              <label for='emailAddress' class='o-form-item__label'>
                Email Address <span class='field-required'>*</span>
              </label>
              <div class="confirmation__registration__email">
                {placeholderPolyfill(
                  <input id='emailAddress'
                    class='o-form-item__txt-input '
                    type={this.browserCapabilities.input.email}
                    placeholder='name@email.com'
                    binding={[leadPassenger, 'emailAddress']}
                    onblur={(event) => {
                      event.target.value = event.target.value.trim()
                      this.fieldVisited(leadPassenger, 'emailAddress')}}
                    name='emailAddress' />,
                  this.browserCapabilities
                )}
                {this.renderValidationError(leadPassenger, 'emailAddress')}
              </div>
            </div>
          </div>
          <div class="confirmation__container__submit-row">
            <div class='confirmation__mobile__row'>
              <label for='mobile_emergency_part' class={['form-item-number-while-away', 'o-choice-item', '-fullWidth', 'u-margin-bottom-none']}>
                <input id='mobile_emergency_part' type='checkbox'
                  class='o-choice-item__checkbox'
                  binding={[leadPassenger.mobileNumber, 'numberWhileAway']}
                />
                <div class='o-choice-item__content'>
                  <span class='mobile_emergency_part_info u-margin-right-medium'>This are the email and phone number I'd like to use on the trip</span>
                </div>
              </label>
            </div>
            <div type='submit' class='confirmation__confirm_details'>
              <button class='btn-primary'
                onclick={ev => {ev.preventDefault(); return this.submitRegistrationDetails()}}>
                Confirm Details
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  }

  render (options) {
    if (this.isExtoleEnabled) {
      this.createExtoleZone()
    }
    return <div id='overview'>
      {this.isExtoleEnabled ? <span id="extole_zone_confirmation"></span> : undefined}
      <div data-test={'confirmation-tab'} class='confirmation u-clearfix'>
        <div class='o-accent-box-summary'>{this.confirmation.renderHeader()}</div>
        {this.serverErrorsPanel}
        {this.renderAirInfoForHiddenExtras()}
        {this.confirmation.isTourOnRequest
          ? undefined
          : <div class="o-accent-box-container">
            {this.renderLeadPassengerConfirmation()}
          </div>
        }
        {this.tourHeader}
        {this.tripSummary}
        <div class='o-accent-box-white'>
          {(() => {
            const warningText = <span>Looking for <a href={this.config.brandPages.brandWebsite}>another tour</a>?</span>
            return options.navigatedBackAfterConfirmation ?
              new Message({
                header: 'Your booking has been completed',
                message: warningText,
                type: MessageTypes.WARNING,
              }) : undefined
          })()}

          {this.confirmation.renderPaymentConfirmation()}

          <div class='confirmation__email'>
            {
              this.booking.confirmation.confirmationEmailAddress
                ? <div>
                  {this.config.confirmationEmail.enabled
                    ? <div>
                      <p>A Booking confirmation email is being sent to <strong>{this.booking.confirmation.confirmationEmailAddress}</strong>.</p>
                      <p>If you do not receive an e-mail within an hour, please contact us</p>
                    </div>
                    : undefined}
                  <p>If you have any query concerning your booking, you can contact our call center at <strong>{this.config.phone.general}</strong></p>
                </div>
                : <div class='u-margin-top-large' >
                  {new Message({
                    header: 'Warnings',
                    message: 'We\'re sorry, your confirmation email has not been sent. Please make a note of your booking reference number.',
                    type: MessageTypes.WARNING,
                  })}
                </div>

            }
          </div>
          {
            this.config.showBaggageNotes && this.booking.quoteCriteria.hasFlights()
              ? <div class='confirmation__baggage-notes'> <h2 class='u-margin-bottom-small'>baggage information</h2> {baggageNotes(this)} </div>
              : undefined
          }
        </div>
        {
          this.config.insurance && this.config.insurance.externalInsuranceProviderUrl
            ? <div class='o-accent-box-white'>
              <div class='external-insurance'>
                <h2 class='u-margin-bottom-small u-margin-top-none'>Manulife Travel Insurance for the Travel Corporation Canadian Guests</h2>
                <p>Manulife's specially designed travel insurance can help protect you from financial worries, in case of the unexpected and you can focus on what matters most, your {this.config.brandFamilyDisplayText} trip. The plan includes cover for Trip Cancellation, Interruption, Missed Connections, Baggage Loss, Damage, Delay and more. You’ll get 24/7 multilingual assistance on our helpline with the added comfort of Medical Concierge Services inclusive of physician consultations.</p>
                <p>Please click the link below to get a no obligation quote on our travel protection. In order to qualify for Manulife's pre-departure any reason cancellation benefit, the policy must be purchased within 72 hours of your tour booking.</p>
                <p><a href={this.config.insurance.externalInsuranceProviderUrl} className="external-insurance-link" target="_blank">Get your insurance quote</a></p>
                <p>For full policy coverage, please select the full duration of your trip and ensure you specify the full non-refundable value of your trip including taxes. Please have your Booking Reference number on hand.</p>
                <p>If you prefer to speak to a Manulife Licensed Advisor please call +1 844 423 3539 on Monday through Friday.</p>
              </div>
            </div>
            : undefined
        }
        { this.config.confirmation.carbonFootprint
          ? <div class="carbon-footprint">{hyperdom.rawHtml('span', this.config.confirmation.carbonFootprint)}</div>
          : undefined
        }
        { this.renderShareConfirmationEmail() }
        {this.confirmation.isTourOnRequest
          ? undefined
          : this.renderEdocs()
        }
      </div>
    </div>
  }
}
